import ActionTypes from '../constants/ActionTypes.ts';
import util from '../lib/util.js';

let initialState = {
  isLogin: false,
  userInfo: {},
  response: {},
};
export default function login(state = initialState, action) {
  var newState = Object.assign({}, state);
  switch (action.type) {
    case ActionTypes.RECEIVE_DATA:
      switch (action.apiName) {
        case 'login':
          if (
            util.isSet('head.status', action.data) &&
            action.data.head.status === 1
          ) {
            //let userInfo = util.copyPropsBySchema(sereGlobal.userInfo, action.data.body.userInfo, ['uid', 'phone', 'nickname', 'photo']);
            newState.isLogin = true;
            //newState.userInfo = userInfo;
          } else {
            newState.isLogin = false;
            newState.userInfo = {};
            newState.response = action.data;
          }
          return newState;
        default:
          return newState;
      }
    default:
      return newState;
  }
}
